import { Table, Typography } from "antd";
import { useMemo, useState } from "react";

const { Title } = Typography;

export default function TrialExamHistory({ trialExams, loading }) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredExams = useMemo(() => {
    if (!trialExams) return [];
    const lower = searchTerm.toLowerCase();
    return trialExams.filter((exam) =>
      [exam.name, exam.code_used, exam.exam_degree]
        .filter(Boolean)
        .some((field) => field.toString().toLowerCase().includes(lower))
    );
  }, [trialExams, searchTerm]);

  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("ar-EG", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }).format(date);
  }

  const columns = [
    {
      title: "الاسم",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "السعر",
      dataIndex: "price",
      key: "price",
      render: (price) => `${price} EGP`,
    },
    {
      title: "الدرجة",
      dataIndex: "exam_degree",
      key: "exam_degree",
    },
    {
      title: "تاريخ الشراء",
      dataIndex: "buy_at",
      key: "buy_at",
      render: formatDate,
    },
    {
      title: "تاريخ الاختبار",
      dataIndex: "exam_submitted_at",
      key: "exam_submitted_at",
      render: formatDate,
    },
    {
      title: "كود الاختبار",
      dataIndex: "code_used",
      key: "code_used",
      render: (code) => code || "-",
    },
  ];

  return (
    <div className="mt-10" dir="rtl">
      <div className="flex items-center justify-between mb-4">
        <Title level={3} className="dark:text-white">
          الإختبارات الشهرية
        </Title>
        <input
          type="text"
          placeholder="البحث علي الإختبارات"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="signin-inputs signin-input my-7 pl-4 max-w-7xl  !text-start placeholder:!text-secondary !border-secondary "
        />
      </div>
      <div className=" w-full  overflow-hidden rounded-xl border-2  border-secondary">
        <Table
          columns={columns}
          dataSource={filteredExams}
          loading={loading}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
}
